import React from "react";
import AddProduct from "../../components/admin/add/AddProduct";

const AddProductPage = () => {
  return (
    <div className="admin-add-product-page">
      <AddProduct />
    </div>
  );
};

export default AddProductPage;
